import { ThemeOptions } from '@mui/material/styles'

export const getThemedComponents = (): ThemeOptions => ({
  components: {},
})
